import React from 'react';
import { DateTime } from 'luxon';
import { useMilestoneTableQuery } from 'generated/graphql';

export type IData = {
  id: string;
  title: string;
  description: string;
  durationInDays: number;
  endDate: DateTime | null;
  installationIds: string[];
  startDate: DateTime;
  status: string;
};

export function useQuery(id: string) {
  const tuple = useMilestoneTableQuery({
    variables: {
      id: id
    },
    skip: id === ''
  });

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.project?.milestones.map((node) => ({
        id: node.id ?? '',
        description: node?.description ?? '',
        durationInDays: node.durationInDays ?? 0,
        endDate: node?.endDate ?? null,
        installationIds: node.installations.map((rec) => rec.id) ?? [],
        startDate: node.startDate,
        status: node.status.displayName ?? '',
        title: node.title ?? ''
      }
      )) ?? [];

      return {
        ...tuple,
        data
      };
    }
    , [tuple]
  );
}
